module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-06.455cd9e3.svg";